import React from 'react';

interface LabelProps {
  className?: string;
  children: React.ReactNode;
  htmlFor?: string;
  id?: string;
  onClick?: (event: React.MouseEvent<HTMLLabelElement>) => void;
}

export const Label: React.FC<LabelProps> = ({ className = '', children, htmlFor, id, onClick }) => {
  return (
    <label
      className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${className}`}
      htmlFor={htmlFor}
      id={id}
      onClick={onClick}>
      {children}
    </label>
  );
};
